import { getStorage, getObjectKey } from '@GUTIL/other'
import { routerMap } from '@GM/Layout/routerMap'
import i18n from '@/i18n'
import { errorModal } from '@GUTIL/prompt'
import { authFlow, authRouterCheck } from '@GUTIL/auth.js'

// 動態載入頁面
export const loadView = (view, path) => {
  let hasPath = !!path
  return () =>
    hasPath
      ? import(
          /* webpackChunkName: "view-[request]" */ `@V/${path}/${view}.vue`
        )
      : import(/* webpackChunkName: "view-[request]" */ `@V/${view}.vue`)
}

// 動態載入頁面(global)
export const loadView_G = (view, path) => {
  let hasPath = !!path
  return () =>
    hasPath
      ? import(
          /* webpackChunkName: "view-[request]" */ `@GV/${path}/${view}.vue`
        )
      : import(/* webpackChunkName: "view-[request]" */ `@GV/${view}.vue`)
}

export const routerCheck = (to, from, next) => {
  const hasToken = getStorage('access_token')
  let hasPermission = permissionCheck(to.name)
  if (authFlow[to.name]) return authRouterCheck(to, from, next)

  switch (to.name) {
    case 'Login':
      hasToken && next('/')
      hasToken || next()
      break
    case 'Home':
      hasToken && next()
      hasToken || next('/Login')
      break
    case 'Maintain':
      hasToken && next()
      hasToken || next('/Login')
      break
    default:
      if (hasToken && hasPermission) {
        next()
      } else if (hasToken && !hasPermission) {
        errorModal({
          title: i18n.t('i18n_page_permission')
        })
        console.error('routerCheck error: 該頁尚無權限，請確認')
        next('/')
      } else {
        next('/Login')
      }
  }
}

// 判別是否有權限
let permissionCheck = routerName => {
  const platform = process.env.FOLDER_NAME
  const currentRouterMap = routerMap[platform]
  const currentRouteKey = getObjectKey(currentRouterMap, routerName) || ''

  const permission = getStorage('permission')
  let matchedRouteKey = Object.keys(permission).find(
    allowKey => currentRouteKey.indexOf(allowKey) >= 0
  )

  const canRead = permission[matchedRouteKey]
    ? permission[matchedRouteKey].canRead
    : false
  return canRead
}
